

























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Model, Prop} from "vue-property-decorator";
import {debounce} from "lodash";
import {suggestReceiver} from "@/modules/regions/services";
import {Location} from "@/interfaces/entity";
import {IdMapper} from "@/interfaces/state/base";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";

@Component({
    name: "AutocompletePhoneCustomer",
    components: {AInputCustom}
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';
    @Prop({ type: String, default: '' }) readonly customerRowGuid!: string;
    @Model("change", {type: String}) readonly phoneNumber!: string;
    onChange = debounce((evt: any) => {
        this.$emit("change", evt.target.value);
    }, 1500);

    dataSource = [];
    locations = [];

    get mapDataSource() {
        const idMapper: IdMapper<Location> = {};
        this.locations.forEach((item: Location) => {
            idMapper[item.id] = item;
        });
        return idMapper;
    }

    onSelect(val: any, option: any) {
        const location = this.mapDataSource[option.key];
        if (!location) return;
        this.$emit("change", location.phoneNumber);
        this.$emit("change-location", location);
    }

    async onSearch(val: any) {
        this.handleSearch(val, this);
    }

    handleSearch = debounce((val: any, vm: any) => {
        suggestReceiver({page: 1, limit: 5, receiver: val,customerRowGuid: this.customerRowGuid}).then(({data}) => {
            vm.locations = data.datas;
            vm.dataSource = data.datas?.map((item: Location) => {
                return {
                    id: item.id.toString(),
                    value: `${item.phoneNumber} - ${item.id}`,
                    text: `${item.phoneNumber} - ${item.name} - ${item.address}, ${item.ward?.name || ''}, ${item.district?.name || ''}, ${item.province?.name || ''}`
                }
            });
        });
    }, 1500)
}
